



























































































import VueTagsInput from "@johmun/vue-tags-input";
import VSwatches from "vue-swatches";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Money } from 'v-money';
import { Circle2 } from 'vue-loading-spinner';
import { CrudModel } from '../../models/crud';
import { uploadFile } from "@/models/request";

@Component({
	components: { VueTagsInput, VSwatches, Money, Circle2 },
})
export default class FormField extends Vue {
	@Prop() private fieldKey: string;
	@Prop() private field: any;
	@Prop() private entity: any;
	@Prop() private schema: any;
	@Prop() private disabled: boolean;
	@Prop() private isNewEntity: boolean;
	@Prop() private subEntityKey: string;
	@Prop() private customLabel: string;
	@Prop() private customKind: string;
	@Prop() private placeholder: string;
	@Prop({ default: false }) private contentOnly: boolean;
	@Prop({ default: false }) private required: boolean;

	// many-to-one properties
	@Prop() manyToOneModel: CrudModel;
	@Prop({ default: "name" }) manyToOneDisplayKey: string;
	@Prop() manyToOneFilter: any;
	@Prop() manyToOneJoinKey: any;
	@Prop() manyToOneDefaultOption: any;
	@Prop() private options: any[];

	manyToOneOptions: any[] = [];

	// one-to-many properties
	currentTag: string = "";
	tags: any[] = [];
	updateOneToMany(newTags: any[]) {
		this.tags = newTags;
		this.entity[this.fieldData.key] = newTags.map(tag => ({ id: tag.id, name: tag.text }));
	}

	get fieldData() {
		if (this.fieldKey && this.schema) {
			return this.schema.find((prop: any) => prop.key === this.fieldKey);
		}
		return this.field;
	}

	get entityKey() {
		if (this.kind === "relation" && this.fieldData.relationType === "many-to-one") {
			return this.subEntityKey || (this.fieldData.key.indexOf(".id") < 0 ? `${this.fieldData.key}.id` : this.fieldData.key);
		}
		return this.subEntityKey || this.fieldData.key;
	}

	get label() {
		return this.customLabel || this.fieldData.name;
	}

	get isRequired() {
		return this.required;
	}

	get kind() {
		return this.customKind || this.fieldData?.kind || '';
	}

	get shouldShow() {
		if (!this.fieldData?.showWhen) {
			return true;
		}
		return this.entity[this.fieldData.showWhen.field] === this.fieldData.showWhen.value;
	}

	async mounted() {
		if (this.schema && this.schema.length) {
			if (this.options) {
				this.manyToOneOptions = this.options;
			}
			await this.initRelations();
		}
	}

	@Watch('schema')
	async schemaChanged(newSchema: any, oldSchema: any) {
		if ((!oldSchema || !oldSchema.length) && newSchema && newSchema.length) { // initialize relation data when schema loads
			await this.initRelations();
		}
	}

	@Watch('manyToOneOptions')
	async manyToOneOptionsChanged(newOptions: any[], previousOptions: any[]) {
		if (previousOptions.length && !newOptions.find(option => option.id === this.entity[this.entityKey])) {
			this.entity[this.entityKey] = null;
		}
	}

	@Watch('options')
	async loadManyToOneOptions() {
		if (this.fieldData?.kind !== 'relation' || this.fieldData?.relationType !== 'many-to-one') {
			return;
		}
		if (this.options) {
			this.manyToOneOptions = this.options;
		} else {
			const searchOptions: any = { search: this.manyToOneFilter };
			const manyToOneModelDescription = await this.manyToOneModel.getDescription();
			if (manyToOneModelDescription.find((field: any) => field.key === 'name')) {
				searchOptions.sort = [{ field: 'name', order: 'ASC'}];
			}
			this.manyToOneOptions = await this.manyToOneModel.search(searchOptions, false, this.manyToOneJoinKey); // load options
		}
		if (this.manyToOneDefaultOption) {
			this.manyToOneOptions.unshift(this.manyToOneDefaultOption);
			this.entity[this.entityKey] = this.manyToOneDefaultOption.id;
		}
	}

	@Watch('manyToOneFilter')
	async filterChanged(newFilter: any, oldFilter: any) {
		if (JSON.stringify(newFilter) !== JSON.stringify(oldFilter)) { // check if filter has actually changed before reloading options
			await this.loadManyToOneOptions();
		}
	}

	async initRelations() {
		await this.loadManyToOneOptions();
		if (this.kind === 'relation' && this.fieldData.relationType === 'one-to-many' && this.entity[this.entityKey]) {
			const currentRelations = this.entity[this.entityKey];
			delete this.entity[this.entityKey];
			this.$set(this.entity, this.entityKey, currentRelations); // force vue to watch this property
			this.tags = this.entity[this.entityKey].map((subEntity: any) => ({ ...subEntity, text: subEntity.name }));
		}
	}

	// File upload
	fileField: any = null;
	uploading = false;
	uploadedFileUrl: string = "";
	async uploadFile(fileList: FileList) {
		this.uploading = true;
		try {
			const { uuid, url } = await uploadFile(fileList[0]);
			this.entity[this.entityKey] = uuid;
			this.uploadedFileUrl = url;
		} catch (error) {
			console.error(error);
			this.$toasted.error("Não foi possível enviar o arquivo. Tente novamente.");
		}
		this.uploading = false;
	}
	clearUpload() {
		this.uploadedFileUrl = '';
		this.entity[this.entityKey] = null;
		this.fileField = null;
	}
}
